import { ICommonSettings, IGpsTrackingBackgroundPermissionLabelSetting, ILanguageModel } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigGpsTrackingBackgroundPermissionLabelsSettings } from "./app-settings-config-gps-tracker-background-permission";

export interface IConfigGpsTrackingBackgroundPermissionInputState {
  showGpsTrackingBackgroundPermissionLabelsModal: boolean;
  editingGpsTrackingBackgroundPermissionLabelsId: string;
}

export interface IConfigGpsTrackingBackgroundPermissionInputProps {
  parentData: string;
  languages: ILanguageModel[];
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigGpsTrackingBackgroundPermissionInput extends PureComponent<
  IConfigGpsTrackingBackgroundPermissionInputProps,
  IConfigGpsTrackingBackgroundPermissionInputState
> {
  formInputName = ["", "gpsTrackingBackgroundPermissionLabelSettingsId"];

  constructor(props: IConfigGpsTrackingBackgroundPermissionInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showGpsTrackingBackgroundPermissionLabelsModal: false,
      editingGpsTrackingBackgroundPermissionLabelsId: ""
    };
  }

  openGpsTrackingBackgroundPermissionLabelsModal = () => {
    this.setState({
      editingGpsTrackingBackgroundPermissionLabelsId: "",
      showGpsTrackingBackgroundPermissionLabelsModal: true
    });
  };

  closeGpsTrackingBackgroundPermissionLabelsModal = () => {
    this.setState({ showGpsTrackingBackgroundPermissionLabelsModal: false });
  };

  setEditingGpsTrackingBackgroundPermissionLabels = (id: string) => {
    this.setState({
      editingGpsTrackingBackgroundPermissionLabelsId: id,
      showGpsTrackingBackgroundPermissionLabelsModal: true
    });
  };

  render() {
    const options = [
      {
        id: null,
        name: "Default"
      } as unknown as IGpsTrackingBackgroundPermissionLabelSetting,
      ...(this.props.commonSettings.gpsTrackingBackgroundPermissionLabelSettings || [])
    ];
    return (
      <>
        <ConfigGpsTrackingBackgroundPermissionLabelsSettings
          formInputName={this.formInputName}
          closeModal={this.closeGpsTrackingBackgroundPermissionLabelsModal}
          showModal={this.state.showGpsTrackingBackgroundPermissionLabelsModal}
          editingGpsTrackingBackgroundPermissionLabelsId={this.state.editingGpsTrackingBackgroundPermissionLabelsId}
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Background Perm. text"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_backgroundperm.text"
              : "ios_gpstracker_backgroundperm.text"
          }
          onAddNew={this.openGpsTrackingBackgroundPermissionLabelsModal}
          onEdit={this.setEditingGpsTrackingBackgroundPermissionLabels}
          dropdownTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_backgroundperm.text"
              : "ios_gpstracker_backgroundperm.text"
          }Dropdown`}
          addNewTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_backgroundperm.text"
              : "ios_gpstracker_backgroundperm.text"
          }AddNewButton`}
          editTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_backgroundperm.text"
              : "ios_gpstracker_backgroundperm.text"
          }EditButton`}
        />
      </>
    );
  }
}
